import { Entity, MicroMClient } from "@mcurros2/microm";
import { DatosServiciosAutorizacionProductosAppSupervisorFiltersDef } from "./DatosServiciosAutorizacionProductosAppSupervisorFiltersDef";

export class DatosServiciosAutorizacionProductosAppSupervisorFilters extends Entity<DatosServiciosAutorizacionProductosAppSupervisorFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosAutorizacionProductosAppSupervisorFiltersDef(), parentKeys);
        this.Form = import('./DatosServiciosAutorizacionProductosAppSupervisorFiltersForm').then((module) => module.DatosServiciosAutorizacionProductosAppSupervisorFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}